import { posthog } from "@service/posthogClient";
import type { OnPageTransitionEndAsync } from "vike/types";

export const onPageTransitionEnd: OnPageTransitionEndAsync = async () => {
	document.querySelector("body")?.classList.remove("page-is-transitioning");
	try {
		const url =
			window.location.pathname + window.location.search + window.location.hash;
		posthog.capture("$pageview", { url });
	} catch {}
};
